import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card.tsx";
import { Separator } from "@/components/ui/separator.tsx";
import { Ticket } from "@/types/ticket.ts";
import { Badge } from "@/components/ui/badge.tsx";
import { cn } from "@/lib/utils.ts";
import { Gift, Star } from "lucide-react";
import { Button } from "@/components/ui/button.tsx";
import { Link } from "react-router";
import { useTranslation } from "@/i18n";

const TicketCard = ({
  ticket,
  mini = false,
}: {
  ticket: Ticket;
  mini?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Card
      className={cn(
        "w-full",
        mini && "flex flex-row justify-between px-6 py-2",
      )}
    >
      {!mini && (
        <>
          <CardHeader className="flex flex-row items-center justify-between">
            <CardTitle>{ticket.draw_name}</CardTitle>
            <Link to={`/raffles/${ticket.draw_id}`}>
              <Button variant="link" className="p-0">
                {t("tickets.viewDraw")}
              </Button>
            </Link>
          </CardHeader>
          <Separator />
        </>
      )}

      <CardContent className={cn("flex gap-4", mini && "p-0")}>
        <div>{t("tickets.ticketNumber", { number: ticket.number })}</div>
        <div className="flex gap-2">
          {ticket.is_free && (
            <Badge variant="secondary">
              <Gift />
              {t("tickets.freeEntry")}
            </Badge>
          )}
          {!!ticket.subscription && <Badge>{t("common.subscription")}</Badge>}
          {!!ticket.prize_id && (
            <Badge className="bg-amber-500">
              <Star />
              {t("tickets.winner")}
            </Badge>
          )}
        </div>
      </CardContent>
      <CardFooter className={cn(mini && "p-0")}>
        <div className={cn("w-full", !mini && "text-xs")}>
          {ticket.is_free ? t("tickets.grantedAt") : t("tickets.purchasedAt")}
          <span>
            {new Date(ticket.purchased_at).toLocaleString("en-US", {})}
          </span>
        </div>
      </CardFooter>
    </Card>
  );
};

export default TicketCard;
